import { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../hooks/useAuthStore'
import { CheckingAuth } from '../common';

import { LoginPage } from 'components/auth/pages/LoginPage'
import { AdminLayout } from "layouts/AdminLayout";

import { PrivateRoutes } from './PrivateRoutes';
import { PublicRoutes } from './PublicRoutes';


const AppRouter = () => {
    
    const { checkAuthToken, status } = useAuthStore()

    const navigate = useNavigate();

    const getLastPathByRenewToken = () => {
        
        // console.log('getLastPathByRenewToken ---- ', status)

        if (status === 'authenticated'){

            // Recupera la ultima pagina visitada
            const lastPath = localStorage.getItem('lastPath') || '/'

            // lleva al usuario a la ultima pantalla visitada
            navigate( lastPath, {
                replace: true
            });
        }
        
    }
    
    useEffect(() => {

        checkAuthToken()
        
    }, [])


    useEffect(() => {

        getLastPathByRenewToken()
        
    }, [status])


    if (status === 'checking') {
        return (
            <div
                role="status"
                aria-label="Verificando sesión"
                style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#1c1c1c',
                }}
            >
                <CheckingAuth />
            </div>
        )
    }

    return (
        <Routes>
            
            <Route path="/auth/login" element={
                    <PublicRoutes status={status}>
                        <LoginPage />
                    </PublicRoutes>
                }
            />
            
            <Route path="/*" element={
                    <PrivateRoutes status={status}>
                        <AdminLayout />
                    </PrivateRoutes>
                } 
            />

        </Routes>
    )
}

export {
    AppRouter
}